export interface ProductGetFeesResponse {
  '@odata.etag': string;
  amount: number;
  productNumber: string;
  productpricelevelid: string;
  _transactioncurrencyid_value: string;
}
